// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"07b73cf9","63":"07b73cf9","154":"1247c59a","324":"1247c59a","634":"07b73cf9","713":"caedc03f","767":"2731a0e8"}[chunkId] + ".chunk.css";
};